import { gsap } from 'gsap'

import { ScrollTrigger } from 'gsap/ScrollTrigger'

import { SplitText } from 'gsap/SplitText'

gsap.registerPlugin(ScrollTrigger, SplitText)

const HIGHLIGHT_SCROLL_START = 'clamp(top 80%)'
const HIGHLIGHT_MIN_HEADING_HEIGHT = 120
const HIGHLIGHT_SHORT_HEADING_END_PX = 200
const HIGHLIGHT_SHORT_HEADING_END_PX_MOBILE = 100
function initHighlightText() {
    let splitHeadingTargets = document.querySelectorAll('[data-highlight-text]')
    splitHeadingTargets.forEach((heading) => {
        const fadedValue = heading.getAttribute('data-highlight-fade') || 0 // Opacity of letter
        const staggerValue =
            heading.getAttribute('data-highlight-stagger') || 0.1 // Smoother reveal
        const getScrollEnd = () =>
            heading.offsetHeight < HIGHLIGHT_MIN_HEADING_HEIGHT
                ? `+=${window.innerWidth < 1024 ? HIGHLIGHT_SHORT_HEADING_END_PX_MOBILE : HIGHLIGHT_SHORT_HEADING_END_PX}`
                : 'bottom 80%'

        new SplitText(heading, {
            type: 'words, chars',
            autoSplit: true,
            onSplit(self) {
                let ctx = gsap.context(() => {
                    let tl = gsap.timeline()

                    tl.from(
                        self.words,

                        {
                            // color: '#0d0d0d',
                            scrollTrigger: {
                                // markers: true,
                                scrub: true,
                                trigger: heading,
                                // invalidateOnRefresh: true,
                                start: HIGHLIGHT_SCROLL_START,
                                end: getScrollEnd
                            },
                            autoAlpha: fadedValue,
                            duration: 0.00001,
                            stagger: staggerValue,
                            ease: 'none'
                        }
                    )
                })

                initDynamicCustomTextCursor()
                return ctx // return our animations so GSAP can clean them up when onSplit fires
            }
        })
    })
}

// Initialize Highlight Text on Scroll
document.addEventListener('DOMContentLoaded', () => {
    initHighlightText()
})

function initDynamicCustomTextCursor() {
    let cursorItem = document.querySelector('.cursor')
    let cursorParagraph = cursorItem.querySelector('p')
    let targets = document.querySelectorAll('[data-cursor]')
    let xOffset = 6
    let yOffset = -70
    let cursorIsOnRight = false
    let currentTarget = null
    let lastText = ''

    // Position cursor relative to actual cursor position on page load
    gsap.set(cursorItem, { xPercent: xOffset, yPercent: yOffset })

    // Use GSAP quick.to for a more performative tween on the cursor
    let xTo = gsap.quickTo(cursorItem, 'x', { ease: 'power3' })
    let yTo = gsap.quickTo(cursorItem, 'y', { ease: 'power3' })

    // Function to get the width of the cursor element including a buffer
    const getCursorEdgeThreshold = () => {
        return cursorItem.offsetWidth + 16 // Cursor width + 16px margin
    }

    // On mousemove, call the quickTo functions to the actual cursor position
    window.addEventListener('mousemove', (e) => {
        let windowWidth = window.innerWidth
        let windowHeight = window.innerHeight
        let scrollY = window.scrollY
        let cursorX = e.clientX
        let cursorY = e.clientY + scrollY // Adjust cursorY to account for scroll

        // Default offsets
        let xPercent = xOffset
        let yPercent = yOffset

        // Adjust X offset dynamically based on cursor width
        let cursorEdgeThreshold = getCursorEdgeThreshold()
        if (cursorX > windowWidth - cursorEdgeThreshold) {
            cursorIsOnRight = true
            xPercent = -100
        } else {
            cursorIsOnRight = false
        }

        // Adjust Y offset if in the bottom 10% of the current viewport
        if (cursorY > scrollY + windowHeight * 0.9) {
            yPercent = -120
        }

        if (currentTarget) {
            let newText = currentTarget.getAttribute('data-cursor')
            if (newText !== lastText) {
                // Only update if the text is different
                cursorParagraph.innerHTML = newText
                lastText = newText

                // Recalculate edge awareness whenever the text changes
                cursorEdgeThreshold = getCursorEdgeThreshold()
            }
        }

        gsap.to(cursorItem, {
            xPercent: xPercent,
            yPercent: yPercent,
            duration: 0.9,
            ease: 'power3'
        })
        xTo(cursorX)
        yTo(cursorY - scrollY)
    })

    // Add a mouse enter listener for each link that has a data-cursor attribute
    targets.forEach((target) => {
        target.addEventListener('mouseenter', () => {
            currentTarget = target // Set the current target

            let newText = target.getAttribute('data-cursor')
            // console.log(newText)
            // Update only if the text changes
            if (newText !== lastText) {
                cursorParagraph.innerHTML = newText
                lastText = newText

                // Recalculate edge awareness whenever the text changes
                let cursorEdgeThreshold = getCursorEdgeThreshold()
            }
        })
    })
}

// // Initialize Dynamic Text Cursor (Edge Aware)
// document.addEventListener('DOMContentLoaded', () => {
//     setTimeout(() => {
//         initDynamicCustomTextCursor()
//     }, 1500)
// })
